var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Outings")]),_c('ul',_vm._l((_vm.outings),function(outing){return _c('li',{key:outing.id},[_c('a',{attrs:{"href":'/#/outing/' + outing.id}},[_vm._v(_vm._s(outing.name))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }